import React from 'react';
import styled from 'styled-components';

/**
 * `searchShown` are the Search Console figures switched on; `searchEmpty` is a linked Search Console with
 * no impressions for this URL, which has nothing to draw.
 */
export default function ChartLegend({ hasSrc, hasDst, searchShown, searchEmpty, hasChangeDots, hasErrorDots }) {
    const shown = key => !searchEmpty && searchShown.includes(key);
    const lines = [
        hasSrc && <Item key="src"><Line $color="#a5b4fc" />Organic sessions<Tip title="Google Analytics organic sessions recorded for this URL">?</Tip></Item>,
        hasDst && <Item key="dst"><Line $color="#5eead4" />Organic sessions (destination)<Tip title="Google Analytics organic sessions for the destination URL — the URL this page redirects to">?</Tip></Item>,
        shown('clicks') && <Item key="clicks"><Line $color="#38bdf8" />Clicks<Tip title="Google Search Console clicks for this URL">?</Tip></Item>,
        shown('impressions') && <Item key="impressions"><Line $color="#14b8a6" />Impressions<Tip title="Google Search Console impressions for this URL, on their own scale: the left axis is sessions">?</Tip></Item>,
        shown('position') && <Item key="position"><Line $color="#f97316" />Search position<Tip title="Google Search Console average position for this URL, 1 at the top of the right axis">?</Tip></Item>,
        searchEmpty && searchShown.length > 0 && <Item key="search">Search Console<Note>no impressions</Note></Item>,
    ].filter(Boolean);
    const dots = [
        hasChangeDots && <Item key="change"><Dot $color="#6366f1" />Change</Item>,
        hasErrorDots && <Item key="error"><Dot $color="#dc2626" />HTTP error</Item>,
    ].filter(Boolean);

    if (lines.length === 0 && dots.length === 0) return null;
    return (
        <Wrap>
            {lines}
            {lines.length > 0 && dots.length > 0 && <Sep />}
            {dots}
        </Wrap>
    );
}

const Wrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 4px 4px 8px;
    flex-wrap: wrap;
`;

const Item = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 0.65rem;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.4px;
`;

const Note = styled.span`
    margin-left: 4px;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 500;
`;

const Dot = styled.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $color }) => $color};
    flex-shrink: 0;
`;

const Line = styled.span`
    width: 16px;
    height: 2px;
    border-radius: 2px;
    background: ${({ $color }) => $color};
    flex-shrink: 0;
`;

const Sep = styled.span`
    width: 1px;
    height: 12px;
    background: #e2e8f0;
    flex-shrink: 0;
`;

const Tip = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #e2e8f0;
    color: #64748b;
    font-size: 0.55rem;
    font-weight: 700;
    cursor: help;
    flex-shrink: 0;
`;
